export const reviewSubmitComponentId = (payload) => {
    try {
        const request = typeof payload === 'string' ? JSON.parse(payload) : payload;
        const component = request?.components?.find((commit) => {
            const snapshot = typeof commit.snapshot === 'string'
                ? JSON.parse(commit.snapshot)
                : commit.snapshot;

            return snapshot?.memo?.name === 'reviews::partner-review-form'
                && commit.calls?.some((call) => call.method === 'submit');
        });

        const snapshot = typeof component?.snapshot === 'string'
            ? JSON.parse(component.snapshot)
            : component?.snapshot;

        return snapshot?.memo?.id || null;
    } catch {
        return null;
    }
};

export const dispatchReviewRequestFailure = (payload, status, livewire = window.Livewire) => {
    const componentId = reviewSubmitComponentId(payload);
    const component = componentId ? livewire?.find(componentId) : null;
    const root = component?.el;
    const target = root?.matches('[data-reviews-partner-form]')
        ? root
        : root?.querySelector('[data-reviews-partner-form]');

    if (!target) {
        return false;
    }

    target.dispatchEvent(new CustomEvent('reviews:livewire-request-failed', {
        bubbles: true,
        detail: { status },
    }));

    return true;
};
